import { Dimensions, Platform, StyleSheet } from 'react-native';
import { COLORS } from '../constants/theme';

const { width: screenWidth } = Dimensions.get('window');
const isDesktop = screenWidth >= 768;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: isDesktop ? '#f9fafb' : '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: isDesktop ? 'transparent' : COLORS.primary,
    paddingHorizontal: isDesktop ? 32 : 20,
    paddingVertical: isDesktop ? 16 : 20,
    paddingTop: isDesktop ? 16 : Platform.OS === 'ios' ? 50 : 20,
    borderBottomLeftRadius: isDesktop ? 0 : 20,
    borderBottomRightRadius: isDesktop ? 0 : 20,
    borderBottomWidth: isDesktop ? 1 : 0,
    borderBottomColor: isDesktop ? '#E5E7EB' : 'transparent',
  },
  backButton: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  backIcon: {
    fontSize: 40,
    color: isDesktop ? '#6B7280' : '#FFFFFF',
    fontWeight: '300',
    textAlign: 'center',
    lineHeight: 40,
    marginTop: -2,
  },
  headerTitle: {
    fontSize: isDesktop ? 24 : 18,
    fontWeight: '600',
    color: isDesktop ? '#1F2937' : '#FFFFFF',
    fontFamily: 'Montserrat_600SemiBold',
  },
  headerSpacer: {
    width: 40,
  },
  headerActions: {
    flexDirection: 'row',
    gap: 12,
  },
  headerIconButton: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: '#F3F4F6',
    alignItems: 'center',
    justifyContent: 'center',
  },
  headerIcon: {
    fontSize: 18,
  },
  filterContainer: {
    flexDirection: 'row',
    backgroundColor: '#F3F4F6',
    width: isDesktop ? '40%' : '70%',
    alignSelf: 'center',
    marginVertical: 15,
    borderRadius: 20,
    padding: 3,
  },
  filterTab: {
    flex: 1,
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 16,
    alignItems: 'center',
  },
  filterTabActive: {
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.15,
    shadowRadius: 4,
    elevation: 3,
  },
  filterTabInactive: {
    backgroundColor: 'transparent',
  },
  filterText: {
    fontSize: 13,
    fontWeight: '400',
  },
  filterTextActive: {
    color: '#1F2937',
  },
  filterTextInactive: {
    color: '#6B7280',
  },
  searchAndFiltersContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: isDesktop ? 32 : 16,
    marginTop: 12,
    marginBottom: isDesktop ? 20 : 0,
    gap: 12,
  },
  searchContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: isDesktop ? 10 : 6,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  filtersButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLORS.primary || '#3B82F6',
    paddingHorizontal: 16,
    paddingVertical: isDesktop ? 10 : 8,
    borderRadius: 8,
    gap: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  filtersButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
    fontFamily: 'Montserrat_600SemiBold',
  },
  filtersBadge: {
    backgroundColor: '#FFFFFF',
    borderRadius: 10,
    minWidth: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 6,
    marginLeft: 2,
  },
  filtersBadgeText: {
    fontSize: 11,
    fontWeight: '700',
    color: COLORS.primary || '#3B82F6',
    fontFamily: 'Montserrat_700Bold',
  },
  exportPdfButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLORS.primary,
    paddingHorizontal: 14,
    paddingVertical: isDesktop ? 10 : 8,
    borderRadius: 8,
  },
  exportPdfButtonDisabled: {
    opacity: 0.55,
  },
  exportPdfButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
    fontFamily: 'Montserrat_600SemiBold',
  },
  tableCard: {
    backgroundColor: '#f9fafb',
    marginHorizontal: 32,
    marginBottom: 32,
    borderRadius: 12,
    borderWidth: 0,
    borderColor: 'transparent',
    shadowColor: 'transparent',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0,
    shadowRadius: 0,
    elevation: 0,
    overflow: 'hidden',
  },
  tableCardMobile: {
    flex: 1,
  },
  searchIcon: {
    fontSize: 16,
    color: '#9CA3AF',
    marginRight: 8,
  },
  searchInput: {
    flex: 1,
    fontSize: 14,
    color: '#1F2937',
    fontWeight: '400',
  },
  tableHeader: {
    flexDirection: 'row',
    paddingHorizontal: isDesktop ? 24 : 16,
    paddingVertical: isDesktop ? 14 : 12,
    marginTop: isDesktop ? 0 : 16,
    backgroundColor: isDesktop ? '#F9FAFB' : 'transparent',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
  },
  headerCell: {
    fontSize: isDesktop ? 14 : 13,
    fontWeight: '600',
    color: '#6B7280',
    fontFamily: 'Montserrat_600SemiBold',
  },
  // Event column headers
  eventDateHeader: {
    flex: 1.0,
    textAlign: 'center',
  },
  eventTypeHeader: {
    flex: 1.0,
    textAlign: 'center',
  },
  worstOfHeader: {
    flex: 1.2,
    textAlign: 'left',
  },
  distanceHeader: {
    flex: 1.0,
    textAlign: 'center',
  },
  isinHeader: {
    flex: isDesktop ? 1.0 : 1.2,
  },
  favouriteHeader: {
    flex: isDesktop ? 0.35 : 0.4,
    textAlign: 'center',
  },
  favouriteColumn: {
    flex: isDesktop ? 0.35 : 0.4,
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: 2,
  },
  valorHeader: {
    flex: 0.8,
    textAlign: 'left',
  },
  nameHeader: {
    flex: isDesktop ? 1.8 : 2.2,
  },
  ccyHeader: {
    flex: isDesktop ? 0.5 : 0.6,
    textAlign: 'center',
  },
  issuerHeader: {
    flex: 1.2,
    textAlign: 'left',
  },
  fixingHeader: {
    flex: 0.9,
    textAlign: 'center',
  },
  dateHeader: {
    flex: 1.0,
    textAlign: 'center',
  },
  finalFixingHeader: {
    flex: 0.9,
    textAlign: 'center',
  },
  wofUnderlyingHeader: {
    flex: 1.0,
    textAlign: 'left',
  },
  wofPctHeader: {
    flex: 0.7,
    textAlign: 'center',
  },
  strikePctHeader: {
    flex: 0.7,
    textAlign: 'center',
  },
  distancePctHeader: {
    flex: 0.8,
    textAlign: 'center',
  },
  currentHeader: {
    flex: 0.8,
    textAlign: 'center',
  },
  strikeHeader: {
    flex: 0.8,
    textAlign: 'center',
  },
  riskTableTypeHeader: {
    flex: 0.75,
    textAlign: 'center',
  },
  bidHeader: {
    flex: isDesktop ? 0.7 : 1.0,
    textAlign: 'center',
  },
  askHeader: {
    flex: isDesktop ? 0.7 : 1.0,
    textAlign: 'center',
  },
  listContainer: {
    flex: 1,
    position: 'relative',
    backgroundColor: isDesktop ? '#f9fafb' : '#FFFFFF',
    paddingTop: isDesktop ? 16 : 0,
  },
  productsList: {
    flex: 1,
  },
  skeletonContainer: {
    padding: 16,
    backgroundColor: isDesktop ? '#f9fafb' : '#fff',
  },
  endText: {
    fontSize: 14,
    color: '#10B981',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 2,
  },
  endSubtext: {
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '400',
    textAlign: 'center',
  },

  productRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingHorizontal: isDesktop ? 10 : 16,
    paddingVertical: isDesktop ? 16 : 12,
    borderBottomWidth: isDesktop ? 0 : 1,
    borderBottomColor: '#F1F5F9',
    backgroundColor: '#FFFFFF',
    marginHorizontal: isDesktop ? 24 : 0,
    marginBottom: isDesktop ? 12 : 0,
    borderRadius: isDesktop ? 12 : 0,
    shadowColor: isDesktop ? '#000' : 'transparent',
    shadowOffset: isDesktop ? { width: 0, height: 2 } : { width: 0, height: 0 },
    shadowOpacity: isDesktop ? 0.1 : 0,
    shadowRadius: isDesktop ? 8 : 0,
    elevation: isDesktop ? 3 : 0,
  },
  // Event columns
  eventDateColumn: {
    flex: 1.0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventDateText: {
    fontSize: 12,
    fontWeight: '400',
    color: '#6B7280',
    textAlign: 'center',
    fontFamily: 'Montserrat_400Regular',
  },
  eventTypeColumn: {
    flex: 1.0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  eventTypeText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    fontFamily: 'Montserrat_500Medium',
  },
  worstOfColumn: {
    flex: 1.2,
    paddingLeft: 4,
    justifyContent: 'center',
  },
  worstOfText: {
    fontSize: 12,
    fontWeight: '400',
    color: '#6B7280',
    fontFamily: 'Montserrat_400Regular',
  },
  distanceColumn: {
    flex: 1.0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  distanceText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    fontFamily: 'Montserrat_500Medium',
  },
  isinColumn: {
    flex: isDesktop ? 1.0 : 1.2,
    paddingRight: 4,
  },
  isinText: {
    fontSize: isDesktop ? 13 : 13,
    fontWeight: '400',
    color: '#3E3E3E',
    fontFamily: 'Montserrat_400Regular',
  },
  valorColumn: {
    flex: 0.8,
    paddingRight: 4,
  },
  valorText: {
    fontSize: 13,
    fontWeight: '400',
    color: '#6B7280',
    fontFamily: 'Montserrat_400Regular',
  },
  nameColumn: {
    flex: isDesktop ? 1.8 : 2.2,
    paddingRight: 4,
  },
  nameText: {
    fontSize: isDesktop ? 13 : 14,
    color: '#3E3E3E',
    fontWeight: '400',
    lineHeight: isDesktop ? 18 : 18,
    fontFamily: 'Montserrat_400Regular',
  },
  finalFixingColumn: {
    flex: 0.9,
    alignItems: 'center',
    justifyContent: 'center',
  },
  finalFixingText: {
    fontSize: 12,
    fontWeight: '400',
    color: '#6B7280',
    textAlign: 'center',
    fontFamily: 'Montserrat_400Regular',
  },
  wofUnderlyingColumn: {
    flex: 1.0,
    paddingLeft: 4,
    justifyContent: 'center',
  },
  wofUnderlyingText: {
    fontSize: 12,
    fontWeight: '400',
    color: '#6B7280',
    fontFamily: 'Montserrat_400Regular',
  },
  wofPctColumn: {
    flex: 0.7,
    alignItems: 'center',
    justifyContent: 'center',
  },
  wofPctText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    fontFamily: 'Montserrat_500Medium',
  },
  strikePctColumn: {
    flex: 0.7,
    alignItems: 'center',
    justifyContent: 'center',
  },
  strikePctText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    fontFamily: 'Montserrat_500Medium',
  },
  distancePctColumn: {
    flex: 0.8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  distancePctText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    fontFamily: 'Montserrat_500Medium',
  },
  currentColumn: {
    flex: 0.8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  currentText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    fontFamily: 'Montserrat_500Medium',
  },
  strikeColumn: {
    flex: 0.8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  riskTableTypeColumn: {
    flex: 0.75,
    paddingHorizontal: 2,
    justifyContent: 'center',
  },
  riskTableTypeText: {
    fontSize: 11,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    fontFamily: 'Montserrat_500Medium',
  },
  strikeText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#3E3E3E',
    textAlign: 'center',
    fontFamily: 'Montserrat_500Medium',
  },
  ccyColumn: {
    flex: isDesktop ? 0.5 : 0.6,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: isDesktop ? 0 : 4,
    paddingLeft: 2,
  },
  ccyText: {
    fontSize: 13,
    fontWeight: '400',
    color: '#3E3E3E',
    textAlign: 'center',
  },
  issuerColumn: {
    flex: 1.2,
    paddingLeft: 8,
    justifyContent: 'center',
  },
  issuerText: {
    fontSize: 13,
    fontWeight: '400',
    color: '#6B7280',
    fontFamily: 'Montserrat_400Regular',
  },
  fixingColumn: {
    flex: 0.9,
    alignItems: 'center',
    justifyContent: 'center',
  },
  fixingText: {
    fontSize: 12,
    fontWeight: '400',
    color: '#6B7280',
    textAlign: 'center',
    fontFamily: 'Montserrat_400Regular',
  },
  createReportButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLORS.primary,
    paddingHorizontal: 14,
    paddingVertical: isDesktop ? 10 : 8,
    borderRadius: 8,
  },
  createReportButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#FFFFFF',
    fontFamily: 'Montserrat_600SemiBold',
  },
  editReportButton: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 14,
    paddingVertical: isDesktop ? 10 : 8,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: COLORS.primary,
  },
  editReportButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: COLORS.primary,
    fontFamily: 'Montserrat_600SemiBold',
  },
  dateColumn: {
    flex: 1.0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dateText: {
    fontSize: 12,
    fontWeight: '400',
    color: '#6B7280',
    textAlign: 'center',
    fontFamily: 'Montserrat_400Regular',
  },
  bidColumn: {
    flex: isDesktop ? 0.7 : 1.0,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 4,
    paddingHorizontal: 2,
  },
  bidText: {
    fontSize: 13,
    fontWeight: '700',
    textAlign: 'center',
  },
  askColumn: {
    flex: isDesktop ? 0.7 : 1.0,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 4,
    paddingHorizontal: 2,
  },
  askText: {
    fontSize: 13,
    fontWeight: '700',
    textAlign: 'center',
  },
  pricePositive: {
    color: '#1F2937',
  },
  priceNeutral: {
    color: '#9CA3AF',
  },
  negativeNumber: {
    color: '#DC2626',
  },
  arrowIcon: {
    fontSize: 14,
    color: '#9CA3AF',
    marginLeft: 4,
    fontWeight: '400',
  },
  footerLoader: {
    paddingVertical: 24,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  loadingText: {
    marginLeft: 12,
    fontSize: 14,
    color: '#6B7280',
    fontWeight: '500',
  },
  footerContainer: {
    paddingHorizontal: 40,
    paddingVertical: 12,
    paddingBottom: 40,
  },
  loadMoreButton: {
    backgroundColor: '#FFFFFF',
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: COLORS.primary,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 2,
    elevation: 2,
    marginBottom: 35,
  },
  loadMoreText: {
    fontSize: 14,
    fontWeight: '600',
    color: COLORS.primary,
    marginBottom: 2,
  },
  loadMoreSubtext: {
    fontSize: 12,
    color: '#6B7280',
    fontWeight: '400',
  },
  endContainer: {
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    paddingVertical: 16,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  emptyContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 80,
    paddingHorizontal: 40,
  },
  emptyListContent: {
    flexGrow: 1,
  },
  emptyText: {
    fontSize: 18,
    color: '#6B7280',
    textAlign: 'center',
    fontWeight: '500',
    marginBottom: 8,
  },
  errorText: {
    fontSize: 16,
    color: '#ef4444',
    textAlign: 'center',
    marginBottom: 16,
  },
  retryButton: {
    backgroundColor: COLORS.primary,
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
  },
  retryText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '600',
  },
  // Active filters styles
  activeFiltersContainer: {
    backgroundColor: '#f8fafc',
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  activeFiltersTitle: {
    fontSize: 12,
    fontWeight: '600',
    color: '#64748b',
    marginBottom: 8,
  },
  activeFiltersRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  filterChip: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#e0f2fe',
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 6,
    marginRight: 8,
    marginBottom: 4,
  },
  filterChipText: {
    fontSize: 12,
    color: '#0369a1',
    fontWeight: '500',
  },
  filterChipClose: {
    marginLeft: 6,
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: '#0369a1',
    alignItems: 'center',
    justifyContent: 'center',
  },
  filterChipCloseText: {
    fontSize: 12,
    color: '#ffffff',
    fontWeight: '600',
  },
  clearAllButton: {
    backgroundColor: '#ef4444',
    borderRadius: 16,
    paddingHorizontal: 12,
    paddingVertical: 6,
  },
  clearAllText: {
    fontSize: 12,
    color: '#ffffff',
    fontWeight: '600',
  },
  filtersContainer: {
    paddingHorizontal: isDesktop ? 32 : 16,
    marginTop: 12,
    marginBottom: 8,
  },
  filterLoadingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 16,
  },
  filterLoadingText: {
    marginLeft: 8,
    fontSize: 14,
    color: '#6B7280',
  },
  filterEmptyContainer: {
    paddingVertical: 16,
    alignItems: 'center',
  },
  filterEmptyText: {
    fontSize: 14,
    color: '#9CA3AF',
    fontStyle: 'italic',
  },
  riskDistanceFilterSection: {
    paddingHorizontal: isDesktop ? 32 : 16,
    paddingVertical: 12,
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  riskDistanceFilterSubtitle: {
    fontSize: 12,
    color: '#64748b',
    marginBottom: 10,
    lineHeight: 18,
  },
  riskDistanceSliderRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  riskDistanceSlider: {
    flex: 1,
    height: Platform.OS === 'ios' ? 40 : 44,
  },
  riskDistanceFilterLiveValue: {
    fontSize: 20,
    fontWeight: '700',
    color: '#0369a1',
    marginLeft: 12,
    minWidth: 52,
    textAlign: 'right',
  },
});

export default styles;
